// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dlkllfkiqsnpwuxiesue.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRsa2xsZmtpcXNucHd1eGllc3VlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3MTU4ODUsImV4cCI6MjA2OTI5MTg4NX0.ySS4D7O-DDTLVhrYeSmfrqwqRuVDOc4EEIwyqJzCX9A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});